import clsx from 'clsx';
import IconInfo from '~/components/icons/IconInfo';
import {ContentModal} from '~/components/ContentModal.client';
import {useCallback, useState} from 'react';
import {ContentModalEntity} from '~/types';
import {DATA_TEST_IDS} from '~/lib/const';

function ProductDetailHeader({
  title,
  headerRight,
  hideInfoIcon = false,
  data,
  name,
  activeValue,
}: {
  title?: string;
  headerRight?: any;
  hideInfoIcon?: boolean;
  data?: ContentModalEntity;
  name: string;
  activeValue: string | null;
}) {
  const [open, setOpen] = useState(false);

  const handleClickOpen = useCallback(() => {
    setOpen(true);
  }, []);

  const isShowingActiveValue =
    activeValue &&
    /^(color|frame\/lens|frames|lens)$/i.test(name?.toLowerCase());

  return (
    <div
      data-testid={DATA_TEST_IDS.PRODUCT_DETAIL_HEADER}
      className={'flex justify-between items-center mb-1'}
    >
      <div className={'flex justify-start items-center'}>
        {title && (
          <span className={'font-header font-bold text-16/20'}>
            {title.toUpperCase()}
          </span>
        )}
        {isShowingActiveValue && (
          <>
            <span className={'font-header font-bold text-16/20'}>:</span>
            <span className={'font-header text-16/20 capitalize pl-1'}>
              {decodeURIComponent(activeValue)}
            </span>
          </>
        )}
        {!hideInfoIcon && data && (
          <button
            data-testid={DATA_TEST_IDS.BUTTON('modal-open')}
            type="button"
            aria-label="information modal open"
            onClick={handleClickOpen}
          >
            <IconInfo className={clsx(title && 'ml-5')} />
          </button>
        )}
      </div>
      <div
        data-testid={DATA_TEST_IDS.PRODUCT_DETAIL_HEADER_RIGHT}
        className={'flex justify-center items-center'}
      >
        {headerRight}
      </div>

      {data && <ContentModal data={data} open={open} setOpen={setOpen} />}
    </div>
  );
}

export default ProductDetailHeader;
